// Result redirect table from the TLB team (18 outcomes). Result pages already exist in Shopify.
// Only Q2 (color), Q3 (feel) and the Q5 complexion bucket decide the URL.
(function (root) {
  var LIGHT = ['FAIR', 'LIGHT']; // Fair + Light only; Medium through Deep Dark goes to deep bucket
  var COLOR = { RED: 'red', PINK_MAUVE: 'pink-mauve', NUDE_NEUTRAL: 'nude-neutral', BERRY_PLUM: 'berry-plum' };
  var TRACK = { LONG_LASTING: 'long-wear', COMFY_CUTE: 'comfort-color', SUPER_MOISTURIZING: 'shine-hydration' };

  function resultUrl(answers, base) {
    var color = COLOR[answers.Q2], track = TRACK[answers.Q3];
    if (!color || !track) return null;
    var query = '';
    if (track === 'shine-hydration' && (color === 'red' || color === 'berry-plum')) {
      track = 'comfort-color'; query = '?fallback=shine'; // no red / berry shine page
    } else if (track !== 'comfort-color') {
      query = '?complexion=' + (LIGHT.indexOf(answers.Q5) >= 0 ? 'light' : 'deep');
    }
    return (base || '/pages/') + 'quiz-result-' + color + '-' + track + query;
  }

  var SHADE = {
    'red-long-wear': 'Infamous Red',
    'red-comfort-color': 'Bawse Lady',
    'pink-mauve-long-wear': 'Main Character',
    'pink-mauve-comfort-color': 'It Girl + Muse',
    'pink-mauve-shine-hydration': 'Showstopper',
    'nude-neutral-long-wear': 'Pressure',
    'nude-neutral-comfort-color': 'Low Key & Naturalista',
    'nude-neutral-shine-hydration': 'Ringleader',
    'berry-plum-long-wear': '12/10',
    'berry-plum-comfort-color': 'Prima Donna & Rebel'
  };

  function resultName(url) {
    var path = String(url || '');
    var slug = (path.match(/quiz-result-([a-z0-9-]+)/) || [])[1];
    if (!slug) return '';
    if (slug === 'red-comfort-color' && /(?:\?|&)fallback=shine(?:&|$)/.test(path)) return 'Rich Auntie';
    return SHADE[slug] || '';
  }

  var api = { resultUrl: resultUrl, resultName: resultName };
  if (typeof module !== 'undefined') module.exports = api; else root.TLBRouting = api;
})(this);
